import { DataServiceService } from "./../../../app/service/data-service.service";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CoreMenuService } from "@core/components/core-menu/core-menu.service";

@Component({
  selector: "[core-menu]",
  templateUrl: "./core-menu.component.html",
  styleUrls: ["./core-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;
  hasCarte: boolean = false;
  @Input()
  layout = "vertical";

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
    private dataservice: DataServiceService
  ) {
    //this.dataservice.data$.subscribe((d) => {this.menu[2].children[3].hidden = d.haveCards === 'false'});
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    this._coreMenuService.onMenuChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.currentUser = this._coreMenuService.currentUser;
        this.menu = this._coreMenuService.getCurrentMenu();
        this.toggleMarchandMenu();
        this._changeDetectorRef.markForCheck();
      });

    // apply once at init too
    this.toggleMarchandMenu();
  }

  private toggleMarchandMenu(): void {
    const isMarchand = !!localStorage.getItem("display");

    if (Array.isArray(this.menu)) {
      this.menu.forEach((section) => {
        if (section.id === "marchand-autres") {
          section.hidden = !isMarchand;
          section.children?.forEach((child) => (child.hidden = !isMarchand));
        }
      });
    }
  }
}
